import { defineComponent as K, onMounted as L, onBeforeUnmount as V, computed as b, watch as j, createBlock as d, openBlock as r, withCtx as a, createVNode as n, unref as u, createTextVNode as y, createElementVNode as w, createElementBlock as x, Fragment as A, renderList as O, withModifiers as H } from "vue";
import { useModal as I } from "@scalar/components";
import { cookieSchema as R } from "@scalar/oas-utils/entities/cookie";
import { useRouter as W, useRoute as q } from "vue-router";
import D from "../../components/EmptyState.vue.js";
import F from "../../components/Sidebar/SidebarButton.vue.js";
import P from "../../components/Sidebar/SidebarList.vue.js";
import T from "../../components/Sidebar/SidebarListElement.vue.js";
import U from "../../components/ViewLayout/ViewLayout.vue.js";
import z from "../../components/ViewLayout/ViewLayoutContent.vue.js";
import G from "../../components/ViewLayout/ViewLayoutSection.vue.js";
import { PathId as M } from "../../routes.js";
import J from "./CookieForm.vue.js";
import Q from "./CookieModal.vue.js";
import { useActiveEntities as X } from "../../store/active-entities.js";
import { useWorkspace as Y } from "../../store/store.js";
import Z from "../../components/Sidebar/Sidebar.vue.js";
const ee = { class: "flex-1" }, oe = { class: "relative mb-[.5px] last:mb-0" }, be = /* @__PURE__ */ K({
  __name: "Cookies",
  setup(te) {
    const { cookies: c, cookieMutators: k, events: v, workspaceMutators: C } = Y(), { activeWorkspace: l, activeCookieId: g } = X(), m = W(), h = q(), f = I(), E = (o) => {
      var e, i;
      const t = R.parse({
        name: o.name,
        value: o.value,
        domain: o.domain,
        path: "/"
      });
      k.add(t), C.edit((e = l.value) == null ? void 0 : e.uid, "cookies", [
        ...((i = l.value) == null ? void 0 : i.cookies) ?? [],
        t.uid
      ]), m.push({
        name: "cookies",
        params: {
          cookies: t.uid
        }
      });
    }, N = (o) => {
      var e, i;
      k.delete(o), C.edit((e = l.value) == null ? void 0 : e.uid, "cookies", [
        ...(((i = l.value) == null ? void 0 : i.cookies) ?? []).filter((s) => s !== o)
      ]);
      const t = Object.values(c).filter(
        (s) => s.uid !== o
      );
      if (t.length > 0) {
        const s = t[t.length - 1];
        s && m.push(s.uid);
      } else
        m.push({
          name: "cookies",
          params: {
            [M.Cookies]: "default"
          }
        });
    }, p = () => {
      f.show();
    }, _ = (o) => {
      o != null && o.createNew && h.name === "cookies" && p();
    }, S = (o, t) => {
      var i;
      const e = {
        name: "cookies",
        params: {
          workspace: ((i = l.value) == null ? void 0 : i.uid) ?? "default",
          cookies: t
        }
      };
      if (o.metaKey) {
        const s = m.resolve(e).href;
        window.open(s, "_blank");
        return;
      }
      m.push(e);
    };
    L(() => v.hotKeys.on(_)), V(() => v.hotKeys.off(_));
    const $ = b(
      () => c[g.value]
    ), B = b(
      () => Object.keys(c).length > 0 && $.value
    );
    return j(
      () => h.query.openCookieModal,
      (o) => {
        o === "true" && p();
      },
      { immediate: !0 }
    ), (o, t) => (r(), d(U, null, {
      default: a(() => [
        n(u(Z), { title: "Cookies" }, {
          content: a(() => [
            w("div", ee, [
              n(P, null, {
                default: a(() => [
                  (r(!0), x(A, null, O(Object.values(u(c)), (e) => (r(), x("li", {
                    key: e.uid,
                    class: "gap-1/2 flex flex-col"
                  }, [
                    w("div", oe, [
                      (r(), d(T, {
                        key: e.uid,
                        class: "text-xs",
                        isDeletable: "",
                        to: {
                          name: "cookies",
                          params: {
                            [u(M).Cookies]: e.uid
                          }
                        },
                        type: "cookies",
                        variable: { name: e.name, uid: e.uid },
                        warningMessage: "Are you sure you want to delete this cookie?",
                        onClick: H((i) => S(i, e.uid), ["prevent"]),
                        onDelete: (i) => N(e.uid)
                      }, null, 8, ["to", "variable", "onClick", "onDelete"]))
                    ])
                  ]))), 128))
                ]),
                _: 1
              })
            ])
          ]),
          button: a(() => [
            n(F, {
              click: p,
              hotkey: "N"
            }, {
              title: a(() => t[1] || (t[1] = [
                y(" Add Cookie ")
              ])),
              _: 1
            })
          ]),
          _: 1
        }),
        n(z, { class: "flex-1" }, {
          default: a(() => [
            B.value ? (r(), d(G, {
              key: 0,
              class: "*:border-b-0"
            }, {
              title: a(() => t[2] || (t[2] = [
                y("Edit Cookie")
              ])),
              default: a(() => [
                n(J)
              ]),
              _: 1
            })) : (r(), d(D, { key: 1 }))
          ]),
          _: 1
        }),
        n(Q, {
          state: u(f),
          onCancel: t[0] || (t[0] = (e) => u(f).hide()),
          onSubmit: E
        }, null, 8, ["state"])
      ]),
      _: 1
    }));
  }
});
export {
  be as default
};
